<template>
  <el-row class="lx-step-bar" type="flex" align="middle">
    <el-col :span="10" class="lx-s-b-left">
      <i class="fa fa-home lx-font-color-active" style="font-size: 20px;"></i>
      <i class="fa fa-angle-right lx-font-color-helper"></i>
      <span class="lx-font-color-helper">{{ stepFirst }}</span>
      <i class="fa fa-angle-right lx-font-color-helper"></i>
      <span class="lx-font-color-active">{{ stepSecond }}</span>
    </el-col>
    <!-- add other custom things in right col, empty is ok -->
    <el-col :span="18" class="lx-s-b-right">
      <slot></slot>
    </el-col>
  </el-row>
</template>

<script>

export default {
  props: [ 'step-first', 'step-second' ]
}
</script>

<style scoped>
.lx-step-bar { padding: 0 10px; border: 1px solid #f0f0f0; height: 50px; font-size: 12px; background-color: #fff; }
.lx-step-bar .lx-s-b-left * { vertical-align: middle; }
i.fa-angle-right { margin: auto 8px; font-size: 20px; }
.lx-step-bar .lx-s-b-right { text-align: right; }
.lx-step-bar /deep/ .lx-s-b-right .el-button { margin-left: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/common/StepBar.vue